"use strict";
import CarrierInvoicesService from "../../services/carrier_invoices_service";
import FactorInvoicesService from "../factor_invoices_service";
import LoadsService from "../loads_service";
const LoadIdAndStatus = React.createClass({
  propTypes: {
    group: React.PropTypes.object.isRequired
  },
  getInitialState: function() {
    return {};
  },
  render: function() {
    if (this.state.message) {
      const classes = "document-browser__collapsed-list-load_ids document-browser__collapsed-list-load_ids-" + this.state.state;
      return /* @__PURE__ */ React.createElement("div", { className: "document-browser__collapsed-list-load_ids-wrapper" }, /* @__PURE__ */ React.createElement("div", { className: "document-browser__collapsed-list-load_ids-label" }, this.state.label), /* @__PURE__ */ React.createElement("div", { className: classes }, this.state.message));
    }
    return /* @__PURE__ */ React.createElement("div", null);
  },
  componentDidMount: function() {
    this.getLoad();
  },
  getLoad: function() {
    const carrierInvoiceId = this.props.group.documents[0].carrier_invoice_id;
    const factorInvoiceId = this.props.group.documents[0].factor_invoice_id;
    if (carrierInvoiceId) {
      this.getLoadFromInvoice(carrierInvoiceId);
    } else if (factorInvoiceId) {
      this.getLoadFromFactorInvoice(factorInvoiceId);
    }
  },
  getLoadFromFactorInvoice: function(factorInvoiceId) {
    let message = "";
    FactorInvoicesService.getWithId(factorInvoiceId).then((invoice) => {
      if (invoice.state === "processed") {
        message = "Processed";
      } else if (invoice.state === "auto_processed") {
        message = "Auto Processed";
      } else if (invoice.state === "approved") {
        message = "Approved";
      } else if (invoice.state === "exception") {
        message = "Incomplete";
      } else if (invoice.state === "abandoned") {
        message = "Ignored";
      } else if (invoice.state === "purchased") {
        message = "Purchased";
      }
      this.setState({ label: "", state: invoice.state, message });
    });
  },
  getLoadFromInvoice: function(carrierInvoiceId) {
    let invoice = CarrierInvoicesService.getInvoiceById(carrierInvoiceId);
    const loadState = LoadsService.getLoadsByInvoiceIds([carrierInvoiceId])[0];
    if (loadState) {
      this.setState({
        message: loadState.load.load_id,
        state: invoice.state,
        label: "Load ID"
      });
    } else {
      const loadStateIds = this.props.group.documents[0].data.load_state_ids;
      if (loadStateIds) {
        LoadsService.getLoad(loadStateIds[0]).then((ls) => {
          invoice = CarrierInvoicesService.getInvoiceById(carrierInvoiceId);
          this.setState({ message: ls.load.load_id, state: invoice.state, label: "Load ID" });
        });
      }
    }
  }
});
export default LoadIdAndStatus;
